import { Col, Flex, Row, Skeleton, Space } from "antd";
import React from "react";
import externalStyles from "./DraftPageSkeleton.module.scss";

export const DraftPageSkeleton = () => {
  const headerStyles: React.CSSProperties = {
    padding: "14px 21px",
    borderBottom: "1px solid #e3e8ee",
    background: "white",
    zIndex: 40,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // height: "76px",
  };

  const controlsStyles: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  };

  const dividerStyles: React.CSSProperties = {
    width: "1px",
    height: "24px",
    background: "#e3e8ee",
    margin: "0 4px",
  };

  const feedbackContainerStyles: React.CSSProperties = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: "white",
    borderLeft: "1px solid #e3e8ee",
  };

  const feedbackTabsStyles: React.CSSProperties = {
    display: "flex",
    borderBottom: "1px solid #e3e8ee",
    background: "#fcfdfe",
    alignItems: "center",
  };

  const feedbackContentStyles: React.CSSProperties = {
    flex: "1",
    overflowY: "auto",
    padding: "16px",
  };

  const feedbackInputStyles: React.CSSProperties = {
    padding: "12px",
    borderTop: "1px solid #e3e8ee",
    background: "#fcfdfe",
  };

  const footerStyles: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "24px",
    background: "white",
    borderTop: "1px solid #e3e8ee",
    flexShrink: 0,
    height: "68px",
  };

  const footerRightStyles: React.CSSProperties = {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginLeft: "auto",
  };

  return (
    <Space
      direction="vertical"
      size={0}
      style={{ width: "100%", height: "100vh" }}
    >
      {/* Skeleton for DraftHeader */}
      <div style={headerStyles}>
        <Flex align="center" gap={12}>
          <Skeleton.Avatar active size={35} shape="circle" />
          <Flex vertical gap={4}>
            <Skeleton.Input
              active
              style={{ width: 150, height: 16, borderRadius: 4 }}
            />
            <Skeleton.Input
              active
              style={{ width: 100, height: 12, borderRadius: 4 }}
            />
          </Flex>
        </Flex>
        <div style={controlsStyles}>
          <Skeleton.Input
            active
            style={{ width: 120, height: 32, borderRadius: 6 }}
          />
          <Skeleton.Input
            active
            style={{ width: 150, height: 32, borderRadius: 999 }}
          />
          <div style={dividerStyles} />
          <Skeleton.Button active shape="circle" />
          <Skeleton.Button active shape="circle" />
        </div>
      </div>

      {/* Skeleton for main content */}
      <Row
        wrap={false}
        style={{ alignItems: "stretch", height: "calc(100vh - 158px)" }}
      >
        <Col
          span={16}
          style={{ padding: "0", display: "flex", flexDirection: "column" }}
        >
          <div
            style={{
              background: "#f8fafc",
              padding: "12px 16px",
              borderBottom: "1px solid #e3e8ee",
            }}
          >
            <Space size="small">
              <Skeleton.Button active style={{ width: 100, borderRadius: 6 }} />
              <Skeleton.Button active style={{ width: 100, borderRadius: 6 }} />
              <Skeleton.Button active style={{ width: 100, borderRadius: 6 }} />
            </Space>
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Skeleton.Node
              active
              style={{ width: "100%", height: "100%" }}
              className={externalStyles.skeletonNode}
            >
              <div />
            </Skeleton.Node>
          </div>
        </Col>
        <Col span={8} style={{ height: "100%", display: "flex" }}>
          <div style={feedbackContainerStyles}>
            <div style={feedbackTabsStyles}>
              <Skeleton
                paragraph={false}
                avatar={false}
                active
                style={{ padding: "10px 10px", height: 40 }}
              />
            </div>
            <div style={feedbackContentStyles}>
              <div style={{ marginBottom: "1rem" }}>
                <Skeleton active paragraph={{ rows: 2 }} />
              </div>
              <div style={{ marginBottom: "1rem" }}>
                <Skeleton active paragraph={{ rows: 3 }} />
              </div>
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
            <div style={feedbackInputStyles}>
              <Skeleton.Input active block />
            </div>
          </div>
        </Col>
      </Row>

      {/* Skeleton for DraftFooter */}
      <div style={footerStyles}>
        <div style={{ flex: 1 }}></div>
        <div style={footerRightStyles}>
          <Skeleton.Button
            active
            style={{ width: 200, height: 40, borderRadius: 8 }}
          />
          <Skeleton.Button
            active
            style={{ width: 150, height: 40, borderRadius: 8 }}
          />
        </div>
      </div>
    </Space>
  );
};
